import { cn, type ClassValue } from "~/lib/utils";

type SpinnerProps = {
  size?: "small" | "medium" | "large";
  className?: ClassValue;
};

export default function Spinner({ size = "medium", className }: SpinnerProps) {
  const sizeClasses = {
    small: "h-4 w-4 border",
    medium: "h-8 w-8 border-2",
    large: "h-12 w-12 border-4",
  };

  return (
    <div
      className={cn(
        // eslint-disable-next-line security/detect-object-injection
        sizeClasses[size],
        "inline-block animate-spin rounded-full",
        "border-solid border-current border-e-transparent",
        "align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite]",
        "text-black",
        className,
      )}
      role="status"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  );
}
